export const DOCUMENT_ELEMENT = document.documentElement;

export const SELECTORS = {
  has_modal: 'has-modal',
  menu_opened: 'menu-opened',
  active: 'is-active',
  hidden: 'is-hidden',
  animated: 'is-animated',
};
